import React, { useEffect, useState } from 'react';
import flashcardService from '../../services/flashcardservice';
import { Link } from 'react-router-dom';

const RecentFlashcards = ({ recentFlashcards: initialCards = null, loading: parentLoading = false }) => {
  const [cards, setCards] = useState(initialCards || []);
  const [loading, setLoading] = useState(parentLoading || (!initialCards));
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    if (initialCards) {
      setCards(initialCards);
      setLoading(false);
      return () => { mounted = false; };
    }

    const fetchRecent = async () => {
      try {
        const res = await flashcardService.getAllFlashcards({ page: 1, limit: 5, sort: '-updatedAt' });
        if (mounted) setCards(res?.data?.flashcards || []);
      } catch (err) {
        if (mounted) setError('Failed to load recent flashcards');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchRecent();
    return () => { mounted = false; };
  }, [initialCards]);

  if (loading) return <div className="text-sm text-gray-500">Loading recent flashcards…</div>;
  if (error) return <div className="text-sm text-red-500">{error}</div>;

  return (
    <div className="space-y-3">
      {cards.length === 0 && (
        <div className="flex items-center justify-between text-sm text-gray-500">
          <span>No recent flashcards.</span>
          <Link to="/flashcards" className="text-blue-600 hover:underline">Generate flashcards</Link>
        </div>
      )}
      {cards.map(card => (
        <div key={card._id} className="p-3 border rounded flex items-start justify-between">
          <div>
            <Link to={`/flashcards`} className="font-semibold text-gray-900 dark:text-white">{card.question || 'Untitled'}</Link>
            <div className="text-xs text-gray-500">{new Date(card.createdAt).toLocaleString()}</div>
          </div>
          <div className="text-sm text-gray-500">{card.mastery ? `${card.mastery}%` : ''}</div>
        </div>
      ))}
    </div>
  );
};

export default RecentFlashcards;
